// Pure helpers for the Gate-4 CellMap — no React, no mapbox, fully unit-testable.
const fmtM = (n) => `$${(Number(n) / 1e6).toFixed(1).replace(/\.0$/, '')}M`;

export const cellsByScale = (data) => (data?.scales || []).slice().sort((a, b) => a.scaleMi - b.scaleMi);

export const pctOfCap = (cell) => (cell?.cap ? Math.round((Number(cell.pml250) / Number(cell.cap)) * 100) : 0);

export const defaultScale = (data) => {
  let best = null;
  cellsByScale(data).forEach((s) =>
    (s.cells || []).forEach((c) => {
      const r = c.cap ? Number(c.pml250) / Number(c.cap) : 0;
      if (!best || r > best.r) best = { r, scale: s.scaleMi };
    })
  );
  return best ? best.scale : cellsByScale(data)[0]?.scaleMi ?? null;
};

export const cellBbox = (cells) => {
  let minLon = Infinity,
    minLat = Infinity,
    maxLon = -Infinity,
    maxLat = -Infinity;
  (cells || []).forEach((c) =>
    (c.polygon || []).forEach(([lon, lat]) => {
      if (lon < minLon) minLon = lon;
      if (lat < minLat) minLat = lat;
      if (lon > maxLon) maxLon = lon;
      if (lat > maxLat) maxLat = lat;
    })
  );
  return [minLon, minLat, maxLon, maxLat];
};

export const cellHeader = (cell) =>
  `SCS zone ${cell.zone} · ${fmtM(cell.pml250)} / ${fmtM(cell.cap)} · ${pctOfCap(cell)}% of cap · ${cell.nLocations} rooftops`;

// YlOrRd-ish ramp for a rooftop's PML contribution (value / cell max).
export const pmlColor = (value, max) => {
  const t = max > 0 ? Math.min(1, Number(value) / Number(max)) : 0;
  const stops = ['#ffffb2', '#fed976', '#feb24c', '#fd8d3c', '#f03b20', '#bd0026'];
  return stops[Math.min(stops.length - 1, Math.floor(t * stops.length))];
};
